import queryString from "query-string";
import { useEffect, useState } from "react";

import { useCustomerServiceApi } from "@/api/hooks/customerService.hook";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

import ResetPasswordForm from "./resetPasswordForm.component";

const ResetPasswordFormContainer = () => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();
    const [isPreLoading, setPreIsLoading] = useState(true);
    const [hasValidToken, setHasValidToken] = useState(false);

    const [{ loading: isLoadingPassword }, checkPasswordValidity] =
        useCustomerServiceApi<void>(
            {
                url: "/customers/ispasswordtokenvalid",
                method: "GET"
            },
            { manual: true, useCache: false }
        );

    const resetPassword = (password: string, token: string, email: string) => {
        return dispatch(CustomerModule.resetPassword(password, token, email));
    };

    const isPasswordTokenValid = (token: string, email: string) => {
        return checkPasswordValidity({ params: { token, email } });
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const { PASSWORDRESETTOKEN: token, EMAIL: email } = queryString.parse(
            location.search
        );

        if (!token || !email) {
            location.assign(Config.pages["request-password"]);
        } else {
            isPasswordTokenValid(token as string, email as string)
                .then(() => {
                    setHasValidToken(true);
                })
                .catch(() => {
                    setHasValidToken(false);
                })
                .finally(() => {
                    setPreIsLoading(false);
                });
        }

        return function cleanUp() {
            setPreIsLoading(true);
            setHasValidToken(false);
        };
    }, []);

    const onSubmit = async (password: string) => {
        const { PASSWORDRESETTOKEN: token, EMAIL: email } = queryString.parse(
            location.search
        );

        const action = await resetPassword(
            password,
            token as string,
            email as string
        );
        if (action.type === CustomerModule.APIStatus.SUCCESS) {
            location.assign(`${Config.pages.login}?passwordsuccess=true`);
        }
    };

    return (
        <ResetPasswordForm
            buttonText={t("account.resetPassword.submit")}
            onSubmit={onSubmit}
            isLoading={isLoadingPassword}
            isPreLoading={isPreLoading}
            hasValidToken={hasValidToken}
        />
    );
};

export { ResetPasswordFormContainer };
